import { ConsoleIcon } from './ConsoleIcon';

/**
 * author: Austin Andrews
 * id DCD0A183-A5DC-43BD-BC48-8FFF0CA0FA9C
 * name console
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/console.svg
 * tags
 */
export const TerminalIcon = ConsoleIcon;
export default TerminalIcon